import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { Order, OrderCountVo, OrderVo, Page } from "@zhihaoscm/entity";

export class OrderService extends BaseService<unknown, OrderVo, unknown, unknown> {
    // 分页查询
    public async customPaging(params: unknown): Promise<Page<OrderVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    // 订单统计
    public async orderStatistic(params: unknown): Promise<OrderCountVo> {
        const { data } = await this.service.get(`${this.path}/order-statistic`, { params });
        return data;
    }

    /**
     * 删除订单
     * */
    public async deleteOrder(id: string): Promise<OrderVo> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /**
     * 取消订单
     * */
    public async cancelOrder(id: string): Promise<OrderVo> {
        const { data } = await this.service.put(`${this.path}/cancel/${id}`);
        return data;
    }

    /**
     * 确认订单
     * */
    public async confirmOrder(id: string, params: unknown): Promise<Order> {
        const { data } = await this.service.post(`${this.path}/${id}`, params);
        return data;
    }
}

export const orderService = new OrderService("/order", httpRequest);
